import { render, staticRenderFns } from "./ParentFirmCreateOrUpdate.vue?vue&type=template&id=202ca94c&"
import script from "./ParentFirmCreateOrUpdate.vue?vue&type=script&lang=js&"
export * from "./ParentFirmCreateOrUpdate.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports